import React from 'react';
import './InputNumber.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import { classNames } from '../../functions/classNames';

const handleChange = (e, format, delegate) => {
  if (format !== undefined && e.target.value.trim() !== '' && !format.test(e.target.value)) {
    return;
  }

  delegate(e);
};

const InputNumber = (props, context) => {


return (	
  <div className={classNames('InputNumber', props.error ? 'hasError' : '')} style={props.style}>
    <div className="inputLabel">
      <span>{getLabel(context.locale, props.label)}</span>
      {props.required ? <span className="required">*</span> : ''}
    </div>
    <input
      type="number"
      name={props.name}
      value={props.name === "revelationHandlingTimeMinutesPre" ? props.value.revelationHandlingTimeMinutesPre :
	  		props.name === "revelationFrequencyOfUseDaysPre" ? props.value.revelationFrequencyOfUseDaysPre :
	  			props.value}
      onChange={(e) => handleChange(e, props.format, props.handleChange)}
      placeholder={props.placeholder ? props.placeholder : ''}
      autoComplete="off"
    />
  </div>
    );
};

InputNumber.contextTypes = {
  locale: PropTypes.string,
};

export default InputNumber;



// WEBPACK FOOTER //
// ./src/main/components/input/InputNumber.js